import { Map, fromJS } from 'immutable';

export function request( state, { customerId, name } ) {
    return state.setIn( [ name, parseInt( customerId, 10 ) ], fromJS( { status: 'IN_PROGRESS' } ) );
}

export function error( state, { customerId, name, errors } ) {
    return state.setIn( [ name, parseInt( customerId, 10 ) ], fromJS( { status: 'ERROR', errors } ) );
}

export function finish( state, { customerId, name, history } ) {
    return state.setIn( [ name, parseInt( customerId, 10 ) ], fromJS( { status: 'FINISHED', items: history } ) );
}

export function clear( state ) {
    return state.set( 'transactions', Map() );
}
